<template>
  <div
    class="grid grid-cols-1-auto gap-2 p-2 hover:bg-gray-200 cursor-pointer justify-between items-center"
    @click="select ? emitSelection() : openManage()"
  >
    <div class="w-full">
      <span class="mr-2" v-if="edit">
        <icon class="-mt-1" name="Edit" />
      </span>
      <span>{{ survey.question }}</span>
      <div class="text-sm italic text-gray-700">
        {{
          $t(`surveys.type.${survey.type}`) +
            ", " +
            $t(`surveys.status.${survey.status}`)
        }}
      </div>
    </div>
    <div class="text-right text-sm text-gray-600">
      {{ survey.updated_at | formatDate }} aktualisiert
    </div>
  </div>
</template>

<script>
import { Survey } from "@/modules/surveys/viewmodels/Survey";
import DateMixin from "@/mixins/DateMixin";

export default {
  name: "Survey",
  mixins: [DateMixin],
  data() {
    return {};
  },
  props: {
    survey: {
      type: Survey,
      required: true,
    },
    select: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  methods: {
    openManage() {
      this.goTo("/survey-manage/" + this.survey.id);
    },
    emitSelection() {
      this.$emit("selection");
    },
  },
  computed: {},
  created() {
    this.voteCount = this.$store.getters["survey/api"].Custom.Votes(
      this.survey.id
    );
  },
};
</script>
